import React from "react";
import "./Loader.css";

const Loader: React.FC = () => {
  return (
      <div className="loader">
        {[...Array(3)].map((_, i) => (
          <div
            key={i}
            className="bar"
            style={{
              animationDelay: `${i * 0.08}s`,
            }}
          ></div>
        ))}
      </div>
  );
};

export default Loader;
